// extracted by mini-css-extract-plugin
module.exports = {"loadingPage":"LoadingPage_loadingPage__2lFAf"};